import gql from 'graphql-tag';
import apollo from 'src/features/apolloSecure';

const query = gql`
query IntentsResolver($operatorId: Int!) {
  skills(operatorId: $operatorId) {
    id
    weight
    requestType {
      name
      id
    }
  }
  groupUsers(userId: $operatorId) {
    id
    activitiesLimit
    group {
      id
      name
    }
  }
  userChannels(userId: $operatorId){
    channel {
      id
      name
    }
  }
  channels {
    id
    name
    allTeamsOn
    teams {
      id
    }
  }
  channelsGroups {
    id
    channels {
      id
    }
  }
}`;

function getOperatorSettings(operatorId) {
  return apollo.client.query({
    variables: { operatorId },
    query,
    fetchPolicy: 'network-only',
  }).then((res) => res.data);
}

export default getOperatorSettings;
